import { TenantEntity } from '@/class/model/TenantEntity'

/**
 * 发票号VO
 * 发票号管理保存也使用了
 */
export class InvoiceNo extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }

  get uuid() {
    return this._data.uuid
  }
  set uuid(uuid) {
    this._data.uuid = uuid
  }
  get version() {
    return this._data.version
  }
  set version(version) {
    this._data.version = version
  }
  get invoiceType() {
    return this._data.invoiceType
  }
  set invoiceType(invoiceType) {
    this._data.invoiceType = invoiceType
  }
  get invoiceNo() {
    return this._data.invoiceNo
  }
  set invoiceNo(invoiceNo) {
    this._data.invoiceNo = invoiceNo
  }
  get invoiceState() {
    return this._data.invoiceState
  }
  set invoiceState(invoiceState) {
    this._data.invoiceState = invoiceState
  }
  get abandoner() {
    return this._data.abandoner
  }
  set abandoner(abandoner) {
    this._data.abandoner = abandoner
  }
  get abandoningDate() {
    return this._data.abandoningDate
  }
  set abandoningDate(abandoningDate) {
    this._data.abandoningDate = abandoningDate
  }
  get user() {
    return this._data.user
  }
  set user(user) {
    this._data.user = user
  }
  get usingDate() {
    return this._data.usingDate
  }
  set usingDate(usingDate) {
    this._data.usingDate = usingDate
  }
  get branchId() {
    return this._data.branchId
  }
  set branchId(branchId) {
    this._data.branchId = branchId
  }
  get purchaseUuid() {
    return this._data.purchaseUuid
  }
  set purchaseUuid(purchaseUuid) {
    this._data.purchaseUuid = purchaseUuid
  }
  get recipientsUuid() {
    return this._data.recipientsUuid
  }
  set recipientsUuid(recipientsUuid) {
    this._data.recipientsUuid = recipientsUuid
  }
  get invoiceUuid() {
    return this._data.invoiceUuid
  }
  set invoiceUuid(invoiceUuid) {
    this._data.invoiceUuid = invoiceUuid
  }
}
